import { render, staticRenderFns } from "./FighterBio.vue?vue&type=template&id=38ce35cc&scoped=true"
import script from "./FighterBio.vue?vue&type=script&lang=js"
export * from "./FighterBio.vue?vue&type=script&lang=js"
import style0 from "./FighterBio.vue?vue&type=style&index=0&id=38ce35cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ce35cc",
  null
  
)

export default component.exports